/* global document,CustomEvent,window,Blob */
import {useState, useEffect} from 'react';

const initConfig = {
    fileName: `GakkiReport-${Date.now()}.txt`,
};

export function useXlsExport() {
    const [data, setData] = useState<{blob: any, name: string}>();

    useEffect(() => {
        if (!data) {
            return;
        }

        let blob;
        try {
            blob = data.blob;
        } catch (error) {
            blob = new Blob(["error type."], {
                type: 'text/plain',
            });
            console.log(error);
        }

        if ((global as any).navigator.msSaveBlob) {
            (global as any).navigator.msSaveBlob(blob, initConfig.fileName)
         } else {
            const url = window.URL.createObjectURL(blob);
            let link: any = document.createElement('a');
    
            link.style = 'display: none';
    
            document.body.append(link);
    
            link.href = url;
            link.download = data?.name || initConfig.fileName;
            link.click();
            link = null;
            window.URL.revokeObjectURL(url);
         }
        
    }, [data]);

    return {data, setData};
}